module.exports = "pegasus_template/assets/themelp1/charity/103.png";